// ============================================================
// types/traslado.types.ts — Traslados de estudiantes
// ============================================================

export type TipoTraslado = 'SALIDA' | 'INGRESO';
export type EstadoTraslado = 'SOLICITADO' | 'APROBADO' | 'EJECUTADO' | 'RECHAZADO';

export interface TrasladoPayload {
  matriculaId: number;
  anioEscolarId: number;
  tipo: TipoTraslado;
  ieNombre: string;
  ieCodigoModular: string;
  ieUgel: string;
  motivo: string;
  observacion?: string;
}

export interface AprobarTrasladoPayload {
  aprobadorId: number;
  observacion?: string;
}

export interface TrasladoResponse {
  idTraslado: number;
  matriculaId: number;
  estudianteId: number;
  estudianteNombres: string;
  estudianteApellidos: string;
  estudianteDni: string;
  anioEscolarId: number;
  anio: number;
  tipo: TipoTraslado;
  estado: EstadoTraslado;
  ieNombre: string;
  ieCodigoModular: string;
  ieUgel: string;
  motivo: string;
  tieneDeuda: boolean;
  deudaExonerada: boolean;
  solicitadoPorId: number;
  solicitadoPorNombre: string;
  aprobadoPorId: number | null;
  aprobadoPorNombre: string | null;
  fechaSolicitud: string;
  fechaAprobacion: string | null;
  fechaEjecucion: string | null;
  observacion: string | null;
}

export const TIPO_TRASLADO_LABEL: Record<TipoTraslado, string> = {
  SALIDA:  'Salida',
  INGRESO: 'Ingreso',
};

export const ESTADO_TRASLADO_LABEL: Record<EstadoTraslado, string> = {
  SOLICITADO: 'Solicitado',
  APROBADO:   'Aprobado',
  EJECUTADO:  'Ejecutado',
  RECHAZADO:  'Rechazado',
};

export const ESTADO_TRASLADO_COLOR: Record<EstadoTraslado, string> = {
  SOLICITADO: 'bg-blue-100 text-blue-700',
  APROBADO:   'bg-green-100 text-green-700',
  EJECUTADO:  'bg-purple-100 text-purple-700',
  RECHAZADO:  'bg-red-100 text-red-700',
};
